module.exports = __webpack_public_path__ + "img/jazz_xxl_light_grey_ba_detail_rsh.92ac3171.jpg";